/* global Foundation */

import $ from 'jquery'
import Promise from 'bluebird'

function getTpl (title, message) {
  return `
    <div data-reveal class="reveal tiny confirm">
      <p class="title">${title}</p>
      <p class="message">${message}</p>
      <p class="buttons">
        <button class="button alert">Igen</button>
        <button class="button secondary">Nem</button>
      </p>
    </div>
  `
}

export default {
  methods: {
    confirm (title, message) {
      return new Promise((resolve, reject) => {
        var modal = $(getTpl(title, message))
        this.confirmElement = modal.appendTo($('body'))
        this.revealElement = new Foundation.Reveal(this.confirmElement, {})
        $('button.alert', this.confirmElement).on('click', () => {
          resolve(true)
          this.confirmElement.foundation('close')
        })
        $('button.secondary', this.confirmElement).on('click', () => {
          resolve(false)
          this.confirmElement.foundation('close')
        })
        this.confirmElement.on('closed.zf.reveal', () => {
          window.setTimeout(() => {
            this.confirmElement.foundation('destroy')
            this.confirmElement.remove()
            this.confirmElement = null
          }, this.revealElement.options.hideDelay)
          resolve(false)
        })
        this.confirmElement.foundation('open')
      })
    },
    _destroyConfirm () {
      window.setTimeout(() => {
      }, this.revealElement.options.hideDelay)
      this.confirmElement.foundation('destroy')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Confirm.js